import { Fragment } from 'react';
import { useRouteQuery } from 'src/common/helpers';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

import { EditEmployeeQuestionnaireSettings } from './components/edit-employee-questionnaire-settings';
import { NewEmployeeQuestionnaireSettings } from './components/new-employee-questionnaire-settings';


const ChangeEmployeeQuestionnaireSettings = () => {
  const query = useRouteQuery();
  const id: string = query.get('id') || '';
  const pageType: string = query.get('type') || '';

  return (
    <Fragment>
      {pageType === SETTINGS_PAGES.employeeQuestionnaire && id === 'new' ? (
        <NewEmployeeQuestionnaireSettings />
      ) : (
        <EditEmployeeQuestionnaireSettings id={id} />
      )}
    </Fragment>
  );
};

export default ChangeEmployeeQuestionnaireSettings;
